

















// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';

// Components
import Modal, { ModalPredefinedStyle } from '@/shared/components/Modal.component.vue';

// Views
import SignaturePartial from '@/client/budget/views/mandate-signature/mandate-actions/sign-modal/signature-partial.vue';


@Component({
    components: {
        Modal,
        SignaturePartial,
    },
})
export default class SignModal extends Vue {
    @Prop() private openModal!: boolean;


    private modalPredefinedStyle = ModalPredefinedStyle;
    private literals = {
        title: 'Firmar documento',
    };


    private closeModal() {
        this.$emit('close-modal');
    }

    private signDocument(signature: string) {
        this.$emit('signature', signature);
    }
}
